import React, { useContext } from "react";
import { ViewContext } from "venuescanner-js/react/components/Inbox/context/ViewContext";
import attachmentLibrary from "venuescanner-js/vanilla/widgets/attachments";
import IconPaperclip from "venuescanner-js/react/components/Objects/Icons/IconPaperclip";
import IconButton from "../../../Chat/Templates/IconButton";

const CtaAttachFile = ({ onAttached }) => {
  const { isMobileDevice } = useContext(ViewContext);

  return (
    <IconButton
      onClick={() =>
        attachmentLibrary.open({ onAttach: onAttached, isMobileDevice })
      }
      icon={<IconPaperclip className="cta-attach-file__icon" />}
      text=""
    />
  );
};

export default CtaAttachFile;
